import campaignsService from '@/services/invitation-campaigns'

// initial state
const state = {
    sso_enabled: false,
    campaigns: [],
}

const CREATE = "CREATE_INVITATION_CAMPAIGN";
const DELETE = "DELETE_INVITATION_CAMPAIGN";
const ADD_EMAILS = "ADD_INVITATION_CAMPAIGN_EMAILS";
const REMOVE_EMAILS = "REMOVE_INVITATION_CAMPAIGN_EMAILS";
const SYNCHRONIZE = "SYNCHRONIZE_INVITATION_CAMPAIGN_SYNCS";

const actionTypes = {
    CREATE,
    DELETE,
    ADD_EMAILS,
    REMOVE_EMAILS,
    SYNCHRONIZE,
}

// actions
const actions = {
    [actionTypes.CREATE] ({ commit, state, dispatch }, { name, surveyPeriodId }) {
        return campaignsService.create(name, surveyPeriodId).then(campaign => {
            commit(mutationTypes.ADD_CAMPAIGN, { campaign });
            return campaign;
        });
    },
    [actionTypes.DELETE] ({ commit, state, dispatch }, { id }) {
        return campaignsService.delete(id).then(campaign => {
            commit(mutationTypes.REMOVE_CAMPAIGN, { campaign });
            return campaign;
        });
    },
    [actionTypes.ADD_EMAILS] ({ commit, state, dispatch }, { id, emails }) {
        return campaignsService.addEmails(id, emails).then(invites => {
            return invites;
        });
    },
    [actionTypes.REMOVE_EMAILS] ({ commit, state, dispatch }, { id, emails }) {
        return campaignsService.removeEmails(id, emails).then(invites => {
            return invites;
        });
    },
    [actionTypes.SYNCHRONIZE] ({ commit, state, dispatch }, { id, emails }) {
        return campaignsService.synchronize(id, emails).then(invites => {
            return invites;
        });
    },
}

const ADD_CAMPAIGN = "ADD_INVITATION_CAMPAIGN";
const REMOVE_CAMPAIGN = "REMOVE_INVITATION_CAMPAIGN";
const mutationTypes = {
    ADD_CAMPAIGN,
    REMOVE_CAMPAIGN,
}

// mutations
const mutations = {
    [mutationTypes.ADD_CAMPAIGN] (state, { campaign }) {
        state.campaigns.push(campaign);
    },
    [mutationTypes.REMOVE_CAMPAIGN] (state, { campaign }) {
        state.campaigns.splice(state.campaigns.findIndex(item => item.id == campaign.id), 1);
    },
}

export default {
    state,
    actions,
    mutations,

    CREATE,
    DELETE,
    ADD_EMAILS,
    REMOVE_EMAILS,
    SYNCHRONIZE,
}
